<template>
    <el-dialog v-dialogDrag :title="title" :visible.sync="show" width="800px">
        <div class="chat-selector">
            <div class="left-box">
                <el-input :placeholder="$t('chat.search')" v-model="searchText" size="small">
                    <i class="el-icon-search el-input__icon" slot="suffix"> </i>
                </el-input>
                <tabs :items="tabItems" :current="tabIdx" @change="onTabChange"></tabs>
                <virtual-scroller v-if="tabIdx == 0" class="left-scroll-box" :items="showConversations">
                    <template v-slot="{ item }">
                        <div class="chat-item" @click="onClickChatItem(item)">
                            <head-image :url="item.headImage" :name="item.showName" :size="42"></head-image>
                            <div class="chat-info">
                                <div class="chat-name">
                                    <div class="chat-name-text"> {{ item.showName }}</div>
                                    <div v-if="item.companyName" class="company-tag-mini">@{{ item.companyName }} </div>
                                    <el-tag v-if="item.type == 'GROUP'" type="primary">{{ $t('chat.groupShort')
                                    }}</el-tag>
                                </div>
                                <div class="chat-content"
                                    v-html="$emo.transform($str.html2Escape(item.lastContent), 'emoji-small')">
                                </div>
                            </div>
                            <el-checkbox v-model="item.checked" class="check-box" @click.native.stop=""
                                @change="onChatChange(item)"></el-checkbox>
                        </div>
                    </template>
                </virtual-scroller>
                <virtual-scroller v-if="tabIdx == 1" class="left-scroll-box" :items="showFriends">
                    <template v-slot="{ item }">
                        <friend-item :menu="false" :friend="item" size="small" @click.native="onClickFriendItem(item)">
                            <el-checkbox v-model="item.checked" class="check-box" @click.native.stop=""
                                @change="onFriendChange(item)"></el-checkbox>
                        </friend-item>
                    </template>
                </virtual-scroller>
                <virtual-scroller v-if="tabIdx == 2" class="left-scroll-box" :items="showGroups">
                    <template v-slot="{ item }">
                        <group-item :group="item" :menu="false" size="small" @click.native="onClickGroupItem(item)">
                            <el-checkbox v-model="item.checked" class="check-box" @click.native.stop=""
                                @change="onGroupChange(item)"></el-checkbox>
                        </group-item>
                    </template>
                </virtual-scroller>
            </div>
            <div class="arrow el-icon-d-arrow-right"></div>
            <div class="right-box">
                <div class="tip">{{ $t('chat.checkedContactsCount', { n: checkedItems.length }) }}</div>
                <el-scrollbar class="right-scroll-box">
                    <div v-for="(item, idx) in checkedItems" :key="idx">
                        <div class="checked-item">
                            <head-image :url="item.headImage" :name="item.showName" :size="36"></head-image>
                            <div class="chat-name">
                                <div class="chat-name-text">{{ item.showName }}</div>
                                <div v-if="item.companyName" class="company-tag-mini"> @{{ item.companyName }}</div>
                            </div>
                            <div class="close" :title="$t('common.remove')" @click.stop="onRemoveItem(item)"><i
                                    class="el-icon-close"></i>
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="clearSelection()">{{ $t('common.clear') }}</el-button>
            <el-button @click="selectAllCurrentTab()">{{ $t('chat.selectAll') }}</el-button>
            <el-button @click="selectAllFriendsAndGroups()">{{ $t('chat.selectAllContactsAndGroups') }}</el-button>
            <el-button @click="close()">{{ $t('common.cancel') }}</el-button>
            <el-button type="primary" @click="ok()">{{ $t('common.send') }}</el-button>
        </span>
    </el-dialog>
</template>
<script>
import HeadImage from '../common/HeadImage.vue';
import Tabs from '../common/Tabs.vue';
import VirtualScroller from '../common/VirtualScroller.vue';
import FriendItem from '../friend/FriendItem.vue';
import GroupItem from '../group/GroupItem.vue';

export default {
    components: { VirtualScroller, HeadImage, Tabs, FriendItem, GroupItem },
    name: "chatSelector",
    props: {
        title: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            show: false,
            maxSelect: 99999,
            searchText: "",
            callback: null,
            tabIdx: 0,
            conversations: [],
            friends: [],
            groups: [],
            checkedItems: []
        }
    },
    methods: {
        open(callback) {
            this.tabIdx = 0;
            this.searchText = "";
            this.show = true;
            this.callback = callback;
            this.initData();
        },
        initData() {
            this.checkedItems = []
            this.conversations = [];
            this.friends = [];
            this.groups = []
            this.chatStore.conversations.forEach(conv => {
                // 过滤掉掉已经删除好友关系或者退群的会话
                if ((this.isPrivate(conv) && this.friendStore.isFriend(conv.targetId))
                    || (this.isGroup(conv) && this.groupStore.isGroup(conv.targetId))) {
                    this.conversations.push({
                        key: conv.key,
                        type: conv.type,
                        targetId: conv.targetId,
                        headImage: conv.headImage,
                        showName: conv.showName,
                        lastContent: conv.lastContent,
                        companyName: conv.companyName,
                        checked: false
                    })
                }
            })
            this.friendStore.friends.forEach(friend => {
                if (!friend.deleted) {
                    this.friends.push({
                        id: friend.id,
                        headImage: friend.headImage,
                        showNickName: friend.showNickName,
                        companyName: friend.companyName,
                        checked: false
                    })
                }
            })
            this.groupStore.groups.forEach(group => {
                if (!group.quit) {
                    this.groups.push({
                        id: group.id,
                        headImage: group.headImage,
                        headImageThumb: group.headImageThumb,
                        showGroupName: group.showGroupName,
                        checked: false
                    })
                }
            })
        },
        close() {
            this.show = false;
        },
        ok() {
            this.close();
            this.callback(this.checkedItems);
        },
        onTabChange(idx) {
            this.tabIdx = idx;
            // 更新选中状态
            this.conversations.forEach(conv => {
                conv.checked = this.checkedItems.some(chatItem => conv.type == chatItem.type && conv.targetId == chatItem.targetId);
            })
            this.friends.forEach(f => {
                f.checked = this.checkedItems.some(chatItem => this.isPrivate(chatItem) && chatItem.targetId == f.id);
            })
            this.groups.forEach(g => {
                g.checked = this.checkedItems.some(chatItem => this.isGroup(chatItem) && chatItem.targetId == g.id);
            })
        },
        isMaxReached() {
            return this.checkedItems.length >= this.maxSelect;
        },
        warnMaxSelect() {
            this.$message.warning(this.$t('chat.maxSelectChats', { n: this.maxSelect }));
        },
        selectAllCurrentTab() {
            if (this.tabIdx == 0) {
                this.conversations.forEach(conv => {
                    this.pushChecked({
                        key: conv.key,
                        type: conv.type,
                        targetId: conv.targetId,
                        showName: conv.showName,
                        headImage: conv.headImage,
                        companyName: conv.companyName
                    }, conv)
                })
            } else if (this.tabIdx == 1) {
                this.friends.forEach(friend => {
                    this.pushChecked({
                        key: this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friend.id),
                        targetId: friend.id,
                        type: this.$enums.CONVERSATION_TYPE.PRIVATE,
                        showName: friend.showNickName,
                        headImage: friend.headImage,
                        companyName: friend.companyName
                    }, friend)
                })
            } else {
                this.groups.forEach(group => {
                    this.pushChecked({
                        key: this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.GROUP, group.id),
                        targetId: group.id,
                        type: this.$enums.CONVERSATION_TYPE.GROUP,
                        showName: group.showGroupName,
                        headImage: group.headImageThumb
                    }, group)
                })
            }
        },
        pushChecked(chatItem, source) {
            if (!this.checkedItems.some(item => item.type == chatItem.type && item.targetId == chatItem.targetId)) {
                this.checkedItems.push(chatItem);
                if (source) {
                    source.checked = true;
                }
            }
        },
        clearSelection() {
            this.checkedItems = [];
            this.conversations.forEach(conv => conv.checked = false);
            this.friends.forEach(friend => friend.checked = false);
            this.groups.forEach(group => group.checked = false);
        },
        selectAllFriendsAndGroups() {
            const selectAll = (list, mapper) => {
                list.forEach(item => {
                    const chatItem = mapper(item);
                    const exists = this.checkedItems.some(c => c.type == chatItem.type && c.targetId == chatItem.targetId);
                    if (!exists) {
                        this.checkedItems.push(chatItem);
                        item.checked = true;
                    }
                })
            };
            selectAll(this.friends, friend => ({
                key: this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friend.id),
                targetId: friend.id,
                type: this.$enums.CONVERSATION_TYPE.PRIVATE,
                showName: friend.showNickName,
                headImage: friend.headImage,
                companyName: friend.companyName
            }));
            selectAll(this.groups, group => ({
                key: this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.GROUP, group.id),
                targetId: group.id,
                type: this.$enums.CONVERSATION_TYPE.GROUP,
                showName: group.showGroupName,
                headImage: group.headImageThumb
            }));
        },
        onClickChatItem(chatItem) {
            if (!chatItem.checked && this.isMaxReached()) {
                this.warnMaxSelect();
                return;
            }
            chatItem.checked = !chatItem.checked;
            this.onChatChange(chatItem);
        },
        onChatChange(chatItem) {
            let idx = this.checkedItems.findIndex(chat => chat.type == chatItem.type && chat.targetId == chatItem.targetId);
            if (idx >= 0) {
                this.checkedItems.splice(idx, 1)
            } else {
                if (this.isMaxReached()) {
                    this.warnMaxSelect();
                    chatItem.checked = false;
                    return;
                }
                this.checkedItems.push(chatItem)
            }
        },
        onClickFriendItem(friend) {
            if (!friend.checked && this.isMaxReached()) {
                this.warnMaxSelect();
                return;
            }
            friend.checked = !friend.checked;
            this.onFriendChange(friend);
        },
        onFriendChange(friend) {
            let idx = this.checkedItems.findIndex(conv => this.isPrivate(conv) && conv.targetId == friend.id);
            if (idx >= 0) {
                this.checkedItems.splice(idx, 1)
            } else {
                if (this.isMaxReached()) {
                    this.warnMaxSelect();
                    friend.checked = false;
                    return;
                }
                let chatItem = {
                    key: this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friend.id),
                    targetId: friend.id,
                    type: this.$enums.CONVERSATION_TYPE.PRIVATE,
                    showName: friend.showNickName,
                    headImage: friend.headImage,
                    companyName: friend.companyName
                }
                this.checkedItems.push(chatItem)
            }
        },
        onClickGroupItem(group) {
            if (!group.checked && this.isMaxReached()) {
                this.warnMaxSelect();
                return;
            }
            group.checked = !group.checked;
            this.onGroupChange(group);
        },
        onGroupChange(group) {
            let idx = this.checkedItems.findIndex(conv => this.isGroup(conv) && conv.targetId == group.id);
            if (idx >= 0) {
                this.checkedItems.splice(idx, 1)
            } else {
                if (this.isMaxReached()) {
                    this.warnMaxSelect();
                    group.checked = false;
                    return;
                }
                let chatItem = {
                    key: this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.GROUP, group.id),
                    targetId: group.id,
                    type: this.$enums.CONVERSATION_TYPE.GROUP,
                    showName: group.showGroupName,
                    headImage: group.headImageThumb
                }
                this.checkedItems.push(chatItem)
            }
        },
        onRemoveItem(chatItem) {
            let idx = this.checkedItems.findIndex(conv => conv.type == chatItem.type && conv.targetId == chatItem.targetId);
            this.checkedItems.splice(idx, 1);
            // 取消选中状态
            let conv = this.conversations.find(conv => conv.type == chatItem.type && conv.targetId == chatItem.targetId);
            if (conv) {
                conv.checked = false;
            }
            if (this.isPrivate(chatItem)) {
                let friend = this.friends.find(f => f.id == conv.targetId);
                if (friend) {
                    friend.checked = false;
                }
            }
            if (this.isGroup(chatItem)) {
                let group = this.groups.find(g => g.id == conv.targetId);
                if (group) {
                    group.checked = false;
                }
            }
        },
        isPrivate(conv) {
            return this.$enums.CONVERSATION_TYPE.PRIVATE == conv.type
        },
        isGroup(conv) {
            return this.$enums.CONVERSATION_TYPE.GROUP == conv.type
        },
    },
    computed: {
        tabItems() {
            return [this.$t('chat.recentChats'), this.$t('chat.friendsTab'), this.$t('chat.groupsTab')];
        },
        showConversations() {
            return this.conversations.filter(conv => conv.showName.includes(this.searchText))
        },
        showFriends() {
            return this.friends.filter(f => f.showNickName.includes(this.searchText))
        },
        showGroups() {
            return this.groups.filter(g => g.showGroupName.includes(this.searchText))
        },
    }
}
</script>

<style scoped lang="scss">
.chat-selector {
    display: flex;

    .left-box {
        width: 48%;
        overflow: hidden;
        border: var(--im-border);

        .left-scroll-box {
            height: 400px;

            .check-box {
                margin-right: 10px;
            }

            .chat-item {
                display: flex;
                align-items: center;
                padding: 5px 10px;
                cursor: pointer;

                .chat-info {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    padding: 0 10px;
                    text-align: left;
                    overflow: hidden;

                    .chat-name {
                        flex: 1;
                        display: flex;
                        align-items: center;

                        .chat-name-text {
                            font-size: var(--im-font-size);
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }

                    .chat-content {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: var(--im-font-size-small);
                        color: var(--im-text-color-light);
                        line-height: 20px;
                        margin-top: 2px;
                    }
                }

                &:hover {
                    background-color: var(--im-background-active);
                }
            }
        }
    }

    .arrow {
        display: flex;
        align-items: center;
        font-size: 20px;
        padding: 10px;
        color: var(--im-color-primary);
    }

    .right-box {
        width: 48%;
        border: var(--im-border);

        .tip {
            text-align: left;
            height: 32px;
            line-height: 32px;
            text-indent: 10px;
            color: var(--im-text-color-light)
        }

        .right-scroll-box {
            height: 460px;

            .checked-item {
                display: flex;
                align-items: center;
                padding: 5px 10px;
                white-space: nowrap;
                cursor: pointer;


                .chat-name {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    padding: 0 10px;

                    .chat-name-text {
                        font-size: var(--im-font-size);
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }

                .close {
                    width: 30px;
                    display: none;
                }

                &:hover {
                    background-color: var(--im-background-active);
                }

                &:hover .close {
                    display: block;
                }
            }
        }
    }
}
</style>
